"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sitemapComponent = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var Breadcrumb_1 = require("@/pages/search/components/Breadcrumb");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var classNames = require("classnames");
var mapStateToProps = function (state) { return (__assign(__assign({}, state), { breadcrumb: state.breadcrumb, sitemapTranslate: state.sitemapTranslate, sitemapItems: state.sitemapItems })); };
var mapDispatchToProps = function () { return ({}); };
exports.sitemapComponent = function (props) {
    var renderSitemapItem = function (sitemapItem, index) {
        var aAttr = sitemapItem.url ? { href: sitemapItem.url } : {};
        var aClasses = classNames(['u-bold', { 'o-link--highlight': sitemapItem.url }]);
        return (React.createElement("li", { className: "l-pad", key: index },
            React.createElement("a", __assign({ className: aClasses }, aAttr, { title: sitemapItem.text, dangerouslySetInnerHTML: { __html: sitemapItem.text } })),
            sitemapItem.sitemapItems ? renderSitemapItems(sitemapItem.sitemapItems) : null));
    };
    var renderSitemapItems = function (sitemapItems) {
        return (React.createElement("ul", { className: "l-pad-around" }, sitemapItems.map(renderSitemapItem)));
    };
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { className: "l-pad-top" },
            React.createElement("div", { className: "l-container l-container--lr" },
                React.createElement("div", { className: "l-container__main" },
                    React.createElement("div", { className: "l-container l-container--lr u-mobile-hidden l-pad-top l-pad--2 t--darker" },
                        React.createElement(Breadcrumb_1.default, null)),
                    React.createElement("div", { className: "l-pad" },
                        React.createElement("div", { className: "c-page-header__body" },
                            React.createElement("div", { className: "c-page-header__title" }, props.sitemapTranslate.title)),
                        renderSitemapItems(props.sitemapItems))))),
        React.createElement(ServerSideSchema_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.sitemapComponent);
